import { SectionNames } from './feedPage.reducer';
import { AppState, FeedPageAppState } from '../../initialStateRegistration';

export const getFeedPage = (state: AppState) => (state as FeedPageAppState).template;

export const getSectionDataByKey = (key: SectionNames) => (state: AppState) => getFeedPage(state)[key];

export const getSectionArticlesByKey = (key: SectionNames) => (state: AppState) => getFeedPage(state)[key].articles;

export const getSectionDisplayNameByKey = (key: SectionNames) => (state: AppState) => getFeedPage(state)[key].displayName;

export const getSectionTextByKey = (key: SectionNames) => (state: AppState) => getFeedPage(state)[key].text;

export const getSectionNextByKey = (key: SectionNames) => (state: AppState) => getFeedPage(state)[key].next;
